import {
  ConfirmActionModal as LibConfirmActionModal,
  ConfirmActionModalProps as LibConfirmActionModalProps,
} from "@flaminem/ui-components";
import { FC } from "react";

import { useT } from "src/internationalization";

export type ConfirmActionModalProps = Omit<LibConfirmActionModalProps, "languageTexts">;

export const ConfirmActionModal: FC<ConfirmActionModalProps> = (props) => {
  const t = useT();

  return (
    <LibConfirmActionModal
      {...props}
      languageTexts={{
        cancel: t("general.actions.cancel"),
        close: t("general.actions.close"),
      }}
    />
  );
};
